// ----DATA-----------------------------------------------

export const UPDATE_ROUTE = "UPDATE_ROUTE";


// ----STALLS DATA-----------------------------------------------

export const UPDATE_ARTICLES_STAGE = "UPDATE_ARTICLES_STAGE";
export const UPDATE_BASKET_CONTENT = "UPDATE_BASKET_CONTENT";
export const EMPTY_BASKET_CONTENT = "EMPTY_BASKET_CONTENT";